"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointsV2 = exports.EndpointsV1 = exports.getServiceEndpointsV1 = void 0;
var getSubdomain = function (forceDev) {
    if (forceDev === void 0) { forceDev = false; }
    return (forceDev ? 'labsdev' : 'labsprod');
};
function getServiceUrl(key, endpoint, forceDev) {
    return "https://".concat(key, ".").concat(getSubdomain(forceDev), ".domotech.io/api/v1/").concat(endpoint);
}
var ServiceEndpoint;
(function (ServiceEndpoint) {
    ServiceEndpoint["Register"] = "register";
    ServiceEndpoint["DomoService"] = "domo-service";
    ServiceEndpoint["GoogleGeocoding"] = "google-geocoding";
    ServiceEndpoint["DomoGeocoder"] = "domo-geocoder";
    ServiceEndpoint["Render"] = "render";
    ServiceEndpoint["VersionManager"] = "version-manager";
    ServiceEndpoint["FeatureSwitch"] = "feature-switch";
    ServiceEndpoint["Pusher"] = "pusher";
})(ServiceEndpoint || (ServiceEndpoint = {}));
// @TODO: add endpoints here as clients are added for each of the services
var getServiceEndpointsV1 = function (forceDev) { return ({
    Register: {
        login: getServiceUrl(ServiceEndpoint.Register, 'authentication/login', forceDev),
        validation: getServiceUrl(ServiceEndpoint.Register, 'authentication/validate', forceDev),
    },
    DomoService: {},
    GoogleGeocoding: {},
    DomoGeocoder: {},
    Render: {},
    VersionManager: {},
    FeatureSwitch: {
        getPrivate: getServiceUrl(ServiceEndpoint.FeatureSwitch, 'featureswitch/private', forceDev),
        getPublic: getServiceUrl(ServiceEndpoint.FeatureSwitch, 'featureswitch/public', forceDev),
    },
    Pusher: {
        channel: getServiceUrl(ServiceEndpoint.Pusher, 'pusher/channel', forceDev),
        authenticate: getServiceUrl(ServiceEndpoint.Pusher, 'pusher/authenticate', forceDev),
        credentials: getServiceUrl(ServiceEndpoint.Pusher, 'pusher/credentials', forceDev),
    },
}); };
exports.getServiceEndpointsV1 = getServiceEndpointsV1;
/**
 * Currently supported endpoints
 *
 * @private
 * */
var EndpointsV1;
(function (EndpointsV1) {
    EndpointsV1["data"] = "/data/v1";
    EndpointsV1["user"] = "/domo/users/v1";
    EndpointsV1["avatar"] = "/domo/avatars/v1";
    EndpointsV1["file"] = "/domo/data-files/v1";
    EndpointsV1["group"] = "/domo/groups/v1";
    EndpointsV1["identity"] = "/domo/environment/v1";
    EndpointsV1["sql"] = "sql/v1";
    EndpointsV1["token"] = "/domo/tokens/v1";
    EndpointsV1["executor"] = "/domo/executor/v1";
    EndpointsV1["ai"] = "/domo/ai/v1";
})(EndpointsV1 = exports.EndpointsV1 || (exports.EndpointsV1 = {}));
var EndpointsV2;
(function (EndpointsV2) {
    EndpointsV2["sql"] = "/data/v2/{alias}/sql";
    EndpointsV2["executor"] = "/domo/executor/v2";
})(EndpointsV2 = exports.EndpointsV2 || (exports.EndpointsV2 = {}));
